import { useCallback } from "react";

// Segment service module for segment operations
const useSegmentService = (api) => {
  const createSegment = useCallback(
    async (segmentData, sortBy = "created_at:desc") => {
      try {
        const requestBody = {
          name: segmentData.name,
          description: segmentData.description || "",
          filters: segmentData.filters,
          isActive: true,
        };
        const response = await api.post(`/${segmentData.moduleName}/segment`, requestBody, {
          params: {
            sortBy: sortBy,
          },
        });
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error creating segment:", error);
        throw error;
      }
    },
    [api]
  );

  const updateSegment = useCallback(
    async (segmentData, segmentId, moduleName) => {
      try {
        const response = await api.put(`/${moduleName}/segment/${segmentId}`, segmentData);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error updating segment:", error);
        throw error;
      }
    },
    [api]
  );

  const getAllSegments = useCallback(
    async (moduleName) => {
      try {
        const response = await api.get(`/${moduleName}/segment`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error fetching segments:", error);
        throw error;
      }
    },
    [api]
  );

  const getSegment = useCallback(
    async (segmentId, moduleName) => {
      try {
        const response = await api.get(`/${moduleName}/segment/${segmentId}`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error fetching segment:", error);
        throw error;
      }
    },
    [api]
  );

  const deleteSegment = useCallback(
    async (segmentId, moduleName) => {
      try {
        const response = await api.delete(`/${moduleName}/segment/${segmentId}`);
        return {
          data: response.data,
          status: response.status,
        };
      } catch (error) {
        console.error("Error deleting segment:", error);
        throw error;
      }
    },
    [api]
  );

  return {
    createSegment,
    updateSegment,
    getAllSegments,
    getSegment,
    deleteSegment,
  };
};

export default useSegmentService;
